import type { apiClient } from '~/shared/api/data-ingestion-api'

/** Cross-event metadata computed in a single pass before per-type transforms */
export interface EventMeta {
  classificationRevalidated: boolean
  dataExtractionDenialRevalidated: boolean
  tagsRevalidated: boolean
  patientMatchRevalidated: boolean
}

/**
 * Single forward pass over filtered events, tracking mutable revalidated state.
 * Each event gets a snapshot of the flags *before* that event updates them,
 * matching the original transform's behavior (title uses pre-update flags).
 */
export function computeEventMeta(events: apiClient.AuditEvent[]): Map<number, EventMeta> {
  const result = new Map<number, EventMeta>()
  let classificationRevalidated = false
  let dataExtractionDenialRevalidated = false
  let tagsRevalidated = false
  let patientMatchRevalidated = false

  for (let i = 0; i < events.length; i++) {
    const event = events[i]
    // Snapshot BEFORE updating flags (matches original transform order)
    result.set(i, {
      classificationRevalidated,
      dataExtractionDenialRevalidated,
      tagsRevalidated,
      patientMatchRevalidated,
    })
    // Update flags after snapshot
    switch (event.event_type) {
      case 'clsrev':
        classificationRevalidated = true
        break
      case 'datarev':
        if (event.data_content?.type === 'denial') {
          dataExtractionDenialRevalidated = true
        } else {
          tagsRevalidated = true
        }
        break
      case 'tagsrev':
        tagsRevalidated = true
        break
      case 'patientrev':
      case 'pa-patientrev':
        patientMatchRevalidated = true
        break
    }
  }

  return result
}
